import { useQuery } from 'react-query';
import { getMyDentist } from 'new/modules/PatientDetailsDashboard/endpoints';

export const useGetMyDentist = (isPatient?: boolean) =>
  useQuery({
    queryKey: ['MY_DENTIST'],
    queryFn: () => getMyDentist.endpoint({}).then((res) => res.data),
    enabled: isPatient,
  });
